import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { RolesOverview } from "@/views/RBAC/RolesOverview";
import { rolesoverview, roleStore, rolesEdit, newRol, cancel } from '@/reducers/Roles'
import {ROLES} from "@/actions/globalConst";
import { show } from '@/reducers/Modal'
import { RoleDetail } from "@/views/RBAC/RoleDetail";

class RolesController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, prevType: props.type };
    this.onSaveHandler = this.onSaveHandler.bind(this);
  }

   componentDidMount() {
        if(history.state?.usr?.rolState) {
            //store.dispatch( cancel() );
        } else if(this.props?.data.apiState == ROLES.API_INIT) {
            store.dispatch( rolesoverview() );
        }
        if(this.props?.selectedId && this.props?.selectedId != "" && (this.props.data.selected.key == "" || this.props.data.selected.key != this.props?.selectedId) ){
            store.dispatch( rolesEdit(this.props.selectedId));
        }
        if(this.props?.view == "add" && this.props.data.selected.key != "") {
            store.dispatch( newRol());
        }
    
    let view = "";
        
   };
    
    onSaveHandler(data) {
            //this.props.navi("/roles/", {replace: true});
        store.dispatch(roleStore(data)).unwrap().then((prop) => {
            this.props.navi("/roles", {replace: false, state: { rolState: "value" }});
        }).catch((error) => {
            
        });

    }
    
  render() {
      if(this.props?.data.apiState == ROLES.API_READY) {

      //if(this.props?.view == "add" || this.props?.view == "edit") {
        if((this.props?.data?.view == ROLES.VIEW_DETAIL || location.pathname.endsWith("/add") ) ||  (location.pathname.search("/edit") > 0 && this.props.data.selected.key != "" )) {
    return (
      <RoleDetail {...this.props}  onSaveHandler={this.onSaveHandler}/>
    );
          
      }
    return (
      <RolesOverview {...this.props}  onSaveHandler={this.onSaveHandler}/>
    );
    
    }
  }
}

const RolesControllerInit = (props) => {
    let { id } = useParams();
    let view = "";
    const navi = useNavigate();
  return (
    <RolesController
      {...props}
      selectedId={id}
      navi={navi}
    />
  );
};

function mapStateToProps(state) {
  const {RolesReducer, AuthReducer} = state;
  
  return {
      data: {...RolesReducer}
      
  };
}
export default connect(mapStateToProps)(RolesControllerInit);
